import React, { useEffect, useState } from "react"
import "../styles/cookieConsentModal.css"

const CookieConsentModal = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent")

    if (!consent) {
      setVisible(true)
    }
  }, [])

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted")
    setVisible(false)
  }

  const refuseCookies = () => {
    localStorage.setItem("cookie-consent", "refused")

    // Redirect away
    window.location.href = "https://www.google.com"
  }

  if (!visible) return null

  return (
    <>
      <div className="cookie-modal">
        <div className="cookie-icon">🍪</div>

        <h2>Votre confidentialité est importante</h2>

        <p>
          Nous utilisons des cookies nécessaires au bon fonctionnement du site
          ainsi que, avec votre accord, des cookies de mesure d'audience.
        </p>

        <a
          href="/politique-cookies"
          className="cookie-policy-link"
        >
          Consulter notre politique de cookies
        </a>

        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-btn-secondary"
            onClick={refuseCookies}
          >
            Refuser
          </button>

          <button
            className="cookie-btn cookie-btn-primary"
            onClick={acceptCookies}
          >
            Accepter
          </button>
        </div>
      </div>
    </>
  )
}

export default CookieConsentModal